export const FirebaseConfig = {
    apiKey: "AIzaSyAE-UupCrfY8WcylVs8e464BAEmKKh7xO8",
    authDomain: "easydrive-e6acb.firebaseapp.com",
    projectId: "easydrive-e6acb",
    storageBucket: "easydrive-e6acb.firebasestorage.app",
    messagingSenderId: "616181434798",
    appId: "1:616181434798:web:63a632522072dcd66c603f",
    measurementId: "G-7ZRP77C12S"
};